import { ChangeDetectorRef, Component, Input, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { InputConverter } from '../../../../inputConverter';
import { LayerService } from '../../../../services/layer.service';
import { HorizontalAlignment, VerticalAlignment } from '../../../../types';
import { BaseSymbolEditorComponent } from '../baseSymbolEditor';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-text-symbol-editor-ng',
    templateUrl: './text-symbol-editor.component.html',
    styleUrls: ['../../../sharedStyles/base.scss', './text-symbol-editor.component.scss']
})
export class TextSymbolEditorComponent extends BaseSymbolEditorComponent {

    @Input() @InputConverter() showTextInput: boolean = true;
    textSymbol: __esri.TextSymbol;
    fontFamily: string;
    horizontalAlignment: HorizontalAlignment;
    verticalAlignment: VerticalAlignment;
    fontSize: number;
    symbolText: string;
    fontWeight: boolean = false;
    fontStyle: boolean = false;
    fontDecoration: boolean = false;
    showColorPicker = false;

    fontFamilyList: string[] = ['arial', 'arial black', 'arial narrow', 'calibri', 'calibri light', 'courier', 'courier new', 'french script mt',
        'georgia', 'sans-serif', 'tahoma', 'times new roman', 'verdana'];
    textSizes = [8, 10, 12, 14, 16, 18, 20, 22, 26, 28, 36, 48, 72];
    horizontalAlignments: string[] = ['left', 'center', 'right'];
    verticalAlignments: string[] = ['baseline', 'top', 'middle', 'bottom'];

    constructor(_vcr: ViewContainerRef, private readonly changeRef: ChangeDetectorRef, protected readonly layerService: LayerService) { super(_vcr, layerService); }

    colorPicker: ViewContainerRef;
    @ViewChild('colorPicker') set colorPickerRef(el: ViewContainerRef) { this.colorPicker = el; }

    bindForm() {
        if (this.layerSymbol) {
            this.textSymbol = this.layerSymbol as __esri.TextSymbol;
            this.fontFamily = this.textSymbol.font.family;
            this.horizontalAlignment = this.textSymbol.horizontalAlignment;
            this.verticalAlignment = this.textSymbol.verticalAlignment;
            this.symbolColor = `rgba(${this.textSymbol.color.toRgba().join(', ')})`;
            this.originalColor = this.symbolColor;
            this.fontSize = this.textSymbol.font.size;
            this.symbolText = this.textSymbol.text;
            this.fontWeight = this.textSymbol.font.weight === 'bold' ? true : false;
            this.fontStyle = this.textSymbol.font.style === 'italic' ? true : false;
            this.fontDecoration = this.textSymbol.font.decoration === 'underline' ? true : false;
            this.changeRef.detectChanges();
        }
    }

    @Input()
    public applyChange = () => {
        this.textSymbol.font.family = this.fontFamily;
        this.textSymbol.horizontalAlignment = this.horizontalAlignment;
        this.textSymbol.verticalAlignment = this.verticalAlignment;
        this.textSymbol.color.setColor(this.symbolColor);
        this.textSymbol.font.size = this.fontSize;
        this.textSymbol.text = this.symbolText;
        this.textSymbol.font.weight = this.fontWeight ? 'bold' : 'normal';
        this.textSymbol.font.style = this.fontStyle ? 'italic' : 'normal';
        this.textSymbol.font.decoration = this.fontDecoration ? 'underline' : 'none';
        window.dispatchEvent(new CustomEvent<string>('symbolChange', { detail: this.uniqueLayerId }));
    }
}
